<template>
  <div class="kb-fault-case">
    <!-- 导航提示标题 -->
    <ml-tip :showHeader="false" content="典型案例分享" />
    <!-- 搜索框 -->
    <ml-tip :showHeader="false" style="border: 0">
      <ml-form inline labelWidth="100px" :model="searchData" ref="searchDataRef">
        <!-- 故障分类 -->
        <ml-select
          prop="firstClassify"
          placeholder="请选择故障分类"
          :options="classifyOptions"
          label="故障分类:"
          keyName="label"
          labelName="label"
          valueName="label"
          v-model="searchData.firstClassify"
          :style="{ marginBottom: 0, marginRight: '40px' }"
          @change="searchFn"
        />
        <!-- 关键词搜索 -->
        <ml-input
          prop="keyword"
          placeholder="请输入关键词搜索"
          label="关键词:"
          :style="{ marginBottom: 0, marginRight: '40px', width: '260px' }"
          v-model="searchData.keyword"
          @keyup.enter="searchFn"
        />
        <!-- 搜索按钮 -->
        <ml-button
          :style="{ 'margin-bottom': 0 }"
          submitText="查询"
          submitIcon="el-icon-search"
          cancelText="重置"
          cancelIcon="el-icon-refresh"
          cancelType="danger"
          @click-cancel="resetSearchData"
          @click-submit="searchFn"
        />
        <!-- 新建在线案例 -->
        <ml-button
          :style="{ 'margin-bottom': 0 }"
          submitText="新建在线案例"
          submitIcon="el-icon-plus"
          submitType="primary"
          :showCancel="false"
          @click-submit="goEdit"
        />
      </ml-form>
    </ml-tip>
    <!-- 数据表格 -->
    <ml-tip :showHeader="false" class="default-tip" style="margin-bottom: 0">
      <!-- 表格 -->
      <el-table :data="tabberData.data" style="width: 100%" :height="tabberHeight(280)">
        <el-table-column align="center" type="index" width="80" label="序号">
          <template #default="scope">
            {{ (tabberData.page - 1) * tabberData.size + (scope.$index + 1) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="案例编号"
          prop="caseId"
          min-width="15%"
          show-overflow-tooltip
        />
        <el-table-column
          align="center"
          label="故障标题"
          prop="faultTitle"
          min-width="15%"
          show-overflow-tooltip
        />
        <el-table-column align="center" label="故障分类" prop="firstClassify" min-width="10%" />
        <el-table-column
          align="center"
          label="涉及设备"
          prop="targetDevice"
          min-width="12%"
          show-overflow-tooltip
        />
        <el-table-column
          align="center"
          label="上报人"
          prop="createUserName"
          min-width="10%"
          show-overflow-tooltip
        />
        <el-table-column align="center" label="上报时间" prop="createTime" min-width="15%" />
        <el-table-column align="center" label="状态" min-width="8%">
          <template #default="scope">
            <el-tag :type="scope.row.validStatus === '1' ? 'success' : 'info'" size="small">
              {{ scope.row.validStatus === '1' ? '已入库' : '草稿' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="300">
          <template #default="scope">
            <el-button size="mini" icon="el-icon-view" type="primary" @click="goDetail(scope.row)">
              查看
            </el-button>
            <el-button
              size="mini"
              icon="el-icon-edit"
              type="warning"
              :disabled="scope.row.validStatus === '1'"
              @click="goEdit(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              v-if="scope.row.validStatus !== '1'"
              size="mini"
              icon="el-icon-delete"
              type="danger"
              @click="clickDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <ml-pagination
        :total="tabberData.total"
        :page="tabberData.page"
        v-model="tabberData.page"
        :size="tabberData.size"
        @current-change="currentChange"
        @size-change="sizeChange"
      />
    </ml-tip>

    <!-- 删除提示框 -->
    <ml-dialog ref="deleteDialogRef" :content="deleteContent" @click-submit="submitDelete" />
  </div>
</template>

<script>
import { onMounted, reactive, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { tabberHeight } from '@/utils'

export default {
  name: 'KbFaultCase',
  setup() {
    const { commit, dispatch } = useStore()
    const router = useRouter()

    // 故障分类下拉选项
    const classifyOptions = ref([
      { label: '全部' },
      { label: '硬件故障' },
      { label: '网络通讯' },
      { label: '数据库' },
      { label: '操作系统' },
      { label: '人为操作' }
    ])

    /* 开始 搜索 **********************************/
    const searchDataRef = ref()
    const searchData = reactive({
      firstClassify: '全部',
      keyword: ''
    })

    // 重置搜索内容
    const resetSearchData = () => {
      searchDataRef.value.CustomFormRef.resetFields()
      searchData.firstClassify = '全部'
      searchData.keyword = ''
      tabberData.page === 1 ? getTabberData() : (tabberData.page = 1)
    }
    // 搜索
    const searchFn = () => {
      tabberData.page === 1 ? getTabberData() : (tabberData.page = 1)
    }
    /* 结束 搜索 **********************************/

    /* 开始 数据列表 ******************************/
    const tabberData = reactive({
      data: [],
      total: 0,
      page: 1,
      size: 10
    })

    // 获取列表数据
    const getTabberData = async () => {
      const params = {
        pageIndex: tabberData.page,
        pageSize: tabberData.size
      }
      // 关键词
      if (searchData.keyword) {
        params.keyword = searchData.keyword
      }
      // 故障分类（全部不传）
      if (searchData.firstClassify && searchData.firstClassify !== '全部') {
        params.firstClassify = searchData.firstClassify
      }
      const res = await dispatch('fetchGetKbFaultCasePage', params)
      if (res && res.code === 200 && res.data) {
        tabberData.data = res.data.records || []
        tabberData.total = res.data.total || 0
        console.log('list', tabberData.data)
      } else {
        tabberData.data = []
        tabberData.total = 0
      }
    }

    // 分页事件
    watch([() => tabberData.page, () => tabberData.size], () => {
      getTabberData()
    })
    const currentChange = page => {
      tabberData.page = page
    }
    const sizeChange = size => {
      tabberData.size = size
    }
    /* 结束 数据列表 ******************************/

    /* 开始 页面跳转 ******************************/
    // 新建/编辑
    const goEdit = row => {
      const caseId = row && row.caseId ? row.caseId : ''
      router.push({ path: '/kbFaultCaseEdit', query: { caseId } })
    }
    // 详情
    const goDetail = row => {
      router.push({ path: '/kbFaultCaseDetail', query: { caseId: row.caseId } })
    }
    /* 结束 页面跳转 ******************************/

    /* 开始 删除 ******************************/
    const deleteDialogRef = ref()
    const deleteContent = ref('')
    const deleteId = ref('')
    // 点击删除
    const clickDelete = row => {
      deleteId.value = row.caseId
      deleteContent.value = `确定删除案例「${row.faultTitle}」吗？`
      deleteDialogRef.value.showDialog = true
    }
    // 确认删除
    const submitDelete = () => {
      dispatch('fetchDeleteKbFaultCase', deleteId.value).then(data => {
        if (data && data.code === 200) {
          commit('setError', {
            status: true,
            title: data.message,
            message: '正在获取新的数据...',
            type: 'success'
          })
          deleteDialogRef.value.showDialog = false
          tabberData.page === 1 ? getTabberData() : (tabberData.page = 1)
        }
      })
    }
    /* 结束 删除 ******************************/

    onMounted(() => {
      getTabberData()
    })

    return {
      classifyOptions,
      searchDataRef,
      searchData,
      resetSearchData,
      searchFn,
      tabberData,
      currentChange,
      sizeChange,
      tabberHeight,
      goEdit,
      goDetail,
      deleteDialogRef,
      deleteContent,
      clickDelete,
      submitDelete
    }
  }
}
</script>

<style lang="scss" scoped>
.kb-fault-case {
  @extend %params-global;
}
</style>
